import React, { createContext, useState, useContext } from 'react';

const UIContext = createContext(null);

export const UIProvider = ({ children }) => {
  // Modal states
  const [showConnectionsModal, setShowConnectionsModal] = useState(false);
  const [showFollowersModal, setShowFollowersModal] = useState(false);
  const [showFollowingModal, setShowFollowingModal] = useState(false);
  const [showProfilePicCropper, setShowProfilePicCropper] = useState(false);
  const [showBannerCropper, setShowBannerCropper] = useState(false);

  // Loading states
  const [uploadingProfilePic, setUploadingProfilePic] = useState(false);
  const [uploadingBanner, setUploadingBanner] = useState(false);
  const [compressingImage, setCompressingImage] = useState(false);

  // Image cropper state
  const [cropperPreset, setCropperPreset] = useState('profilePicture');
  const [cropperImage, setCropperImage] = useState(null);
  const [cropperCallback, setCropperCallback] = useState(null);

  // General modal state for custom modals
  const [customModal, setCustomModal] = useState({
    isOpen: false,
    title: '',
    content: null,
    onClose: null,
  });

  // Open image cropper with preset
  const openImageCropper = (preset, image, callback) => {
    setCropperPreset(preset);
    setCropperImage(image);
    setCropperCallback(() => callback);
    setShowProfilePicCropper(true);
  };

  // Close image cropper
  const closeImageCropper = () => {
    setShowProfilePicCropper(false);
    setCropperImage(null);
    setCropperCallback(null);
  };

  // Open custom modal
  const openCustomModal = (title, content, onClose = null) => {
    setCustomModal({
      isOpen: true,
      title,
      content,
      onClose,
    });
  };

  // Close custom modal
  const closeCustomModal = () => {
    if (customModal.onClose) {
      customModal.onClose();
    }
    setCustomModal({
      isOpen: false,
      title: '',
      content: null,
      onClose: null,
    });
  };

  const value = {
    // Modal states
    showConnectionsModal,
    setShowConnectionsModal,
    showFollowersModal,
    setShowFollowersModal,
    showFollowingModal,
    setShowFollowingModal,
    showProfilePicCropper,
    setShowProfilePicCropper,
    showBannerCropper,
    setShowBannerCropper,

    // Loading states
    uploadingProfilePic,
    setUploadingProfilePic,
    uploadingBanner,
    setUploadingBanner,
    compressingImage,
    setCompressingImage,

    // Image cropper
    cropperPreset,
    cropperImage,
    cropperCallback,
    openImageCropper,
    closeImageCropper,

    // Custom modal
    customModal,
    openCustomModal,
    closeCustomModal,
  };

  return <UIContext.Provider value={value}>{children}</UIContext.Provider>;
};

export const useUI = () => {
  const context = useContext(UIContext);
  if (!context) {
    throw new Error('useUI must be used within UIProvider');
  }
  return context;
};

export default UIContext;
